import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const biIncidentReportsByTypeRequest = createRequest(constants.biIncidentReportsByType);
export const biIncidentReportsByTypeSuccess = createSuccess(constants.biIncidentReportsByType);
export const biIncidentReportsByTypeFailure = createFailure(constants.biIncidentReportsByType);

export const biIncidentReportsGroupedByDateAndTypeRequest = createRequest(constants.biIncidentReportsGroupedByDateAndType);
export const biIncidentReportsGroupedByDateAndTypeSuccess = createSuccess(constants.biIncidentReportsGroupedByDateAndType);
export const biIncidentReportsGroupedByDateAndTypeFailure = createFailure(constants.biIncidentReportsGroupedByDateAndType);

export const biIncidentReportsGroupedByDateRequest = createRequest(constants.biIncidentReportsGroupedByDate);
export const biIncidentReportsGroupedByDateSuccess = createSuccess(constants.biIncidentReportsGroupedByDate);
export const biIncidentReportsGroupedByDateFailure = createFailure(constants.biIncidentReportsGroupedByDate);

export const setLoadingState = createAction(constants.setLoadingState);

export const requestBIIncidentReportsByType = biIncidentReportsByTypeRequest;
export const requestBIIncidentReportsGroupedByDateAndType = biIncidentReportsGroupedByDateAndTypeRequest;
export const requestBIIncidentReportsGroupedByDate = biIncidentReportsGroupedByDateRequest;